import { Form } from 'react-bootstrap';
import type { Member, TeamMatchPlayResults, CurrentRyderCupTeamMember } from '../types/api.types';
import { MemberCard } from './member-card';
import { calculatePlayer1MatchSummary } from './head-to-head.utils';

interface MembersPanelProps {
  members: Member[];
  selectedMember: string | number | null;
  onMemberSelect: (id: string | number | null) => void;
  showLatestRyderCupOnly: boolean;
  onFilterChange: (checked: boolean) => void;
  latestRyderCupTeams: CurrentRyderCupTeamMember[];
  mapSinglesStrokeResults: Record<string | number, Record<string | number, TeamMatchPlayResults[]>>;
  isFilterDisabled: boolean;
}

export function MembersPanel({
  members,
  selectedMember,
  onMemberSelect,
  showLatestRyderCupOnly,
  onFilterChange,
  latestRyderCupTeams,
  mapSinglesStrokeResults,
  isFilterDisabled,
}: MembersPanelProps) {
  return (
    <div style={{ flex: '0 0 30%', display: 'flex', flexDirection: 'column' }}>
      <div style={{ marginBottom: '8px', padding: '8px', background: '#f8f9fa', borderRadius: '4px' }}>
        <Form.Check
          type="checkbox"
          id="ryder-cup-filter"
          label="Show latest Ryd-Her Cup teams only"
          checked={showLatestRyderCupOnly}
          onChange={(e) => onFilterChange(e.target.checked)}
          disabled={isFilterDisabled}
        />
      </div>
      <div
        style={{
          flex: 1,
          overflowY: 'auto',
          border: '1px solid #ccc',
          borderRadius: '4px',
          padding: '12px',
          background: '#fafafa',
        }}
      >
        {members.map((member) => (
          <MemberCard
            key={member.id}
            member={member}
            isSelected={selectedMember === member.id}
            matchSummary={calculatePlayer1MatchSummary(mapSinglesStrokeResults, member.id)}
            onClick={() => onMemberSelect(selectedMember === member.id ? null : member.id)}
            showLatestRyderCupOnly={showLatestRyderCupOnly}
            latestRyderCupTeams={latestRyderCupTeams}
            reverse={false}
          />
        ))}
      </div>
    </div>
  );
}
